// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__keL67","right":"styles_right__3EmAc"};